<div class="p-6 max-w-4xl mx-auto">
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Paramètres</h1>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      Configuration globale du système.
    </p>
  </div>

  <p-tabs [value]="0">
    <p-tablist>
      <p-tab [value]="0">Paramètres</p-tab>
      <p-tab [value]="1">Usines</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="pt-4">
          <div *ngIf="isLoading" class="flex justify-center items-center py-16">
            <i class="pi pi-spin pi-spinner text-4xl text-blue-500"></i>
          </div>

          <div *ngIf="!isLoading" class="flex flex-col gap-4">
            <div
              *ngFor="let config of configs"
              class="bg-white dark:bg-zinc-800 rounded-2xl shadow-sm border border-zinc-100 dark:border-zinc-700 p-6"
            >
              <div
                class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
              >
                <div class="flex-1">
                  <h3
                    class="text-base font-semibold text-gray-800 dark:text-white"
                  >
                    {{ config.ConfigName }}
                  </h3>
                  <p
                    *ngIf="config.Description"
                    class="text-sm text-gray-500 dark:text-gray-400 mt-1"
                  >
                    {{ config.Description }}
                  </p>
                  <span
                    class="inline-block mt-2 text-xs font-medium px-2 py-0.5 rounded-full bg-zinc-100 dark:bg-zinc-700 text-zinc-600 dark:text-zinc-300"
                  >
                    {{ config.ValueType }}
                  </span>
                </div>

                <div class="flex items-center gap-3">
                  <ng-container
                    *ngIf="
                      config.ValueType === 'double' ||
                        config.ValueType === 'float';
                      else textValue
                    "
                  >
                    <p-inputNumber
                      [(ngModel)]="editValues[config.ConfigName]"
                      [min]="0"
                      [max]="1"
                      [step]="0.01"
                      [minFractionDigits]="2"
                      [maxFractionDigits]="2"
                      mode="decimal"
                      inputStyleClass="w-28 text-center"
                    />
                  </ng-container>
                  <ng-template #textValue>
                    <input
                      pInputText
                      [(ngModel)]="editValues[config.ConfigName]"
                      class="w-40"
                    />
                  </ng-template>

                  <p-button
                    label="Sauvegarder"
                    icon="pi pi-save"
                    [loading]="savingKey === config.ConfigName"
                    (click)="save(config)"
                    severity="primary"
                    size="small"
                  />
                </div>
              </div>
            </div>

            <div
              *ngIf="configs.length === 0"
              class="text-center py-12 text-gray-400 dark:text-gray-500"
            >
              <i class="pi pi-cog text-4xl mb-3 block"></i>
              <p>Aucun paramètre configuré.</p>
            </div>
          </div>

          <!-- Nettoyage de la donnée -->
          <div class="mt-10">
            <div class="mb-4">
              <h2 class="text-xl font-bold text-gray-800 dark:text-white">
                Nettoyage de la donnée
              </h2>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Effacement des données saisies par les utilisateurs. Ces
                opérations sont irréversibles.
              </p>
            </div>

            <div class="flex flex-col gap-4">
              <app-data-cleaning-panel
                title="Effacement des doublons sélectionnés"
                description="Réinitialise les sélections de doublons (is_selected) pour les ordres de travail similaires correspondant aux filtres choisis."
                [plantsWithSectors]="plantsWithSectors"
                [isLoading]="isClearingDuplicates"
                confirmKey="clear-duplicates-confirm"
                (clearRequested)="onClearDuplicates($event)"
              />

              <app-data-cleaning-panel
                title="Effacement des priorités sélectionnées"
                description="Réinitialise les priorités choisies par les utilisateurs (selected_priority) pour les ordres de travail correspondant aux filtres choisis."
                [plantsWithSectors]="plantsWithSectors"
                [isLoading]="isClearingPriorities"
                confirmKey="clear-priorities-confirm"
                (clearRequested)="onClearPriorities($event)"
              />
            </div>
          </div>

          <!-- Suppression de données -->
          <div class="mt-10">
            <div class="mb-4">
              <h2 class="text-xl font-bold text-gray-800 dark:text-white">
                Suppression de données
              </h2>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Suppression définitive des données SAP importées. Ces opérations
                sont irréversibles et suppriment toutes les données associées.
              </p>
            </div>

            <div class="flex flex-col gap-4">
              <app-data-cleaning-panel
                title="Suppression des données SAP"
                description="Supprime définitivement les ordres de travail, les avis de travaux et les opérations correspondant aux filtres choisis, ainsi que toutes leurs données associées (doublons, embarquements, catégories, ...)."
                [plantsWithSectors]="plantsWithSectors"
                [isLoading]="isDeletingSapData"
                confirmKey="delete-sap-data-confirm"
                (clearRequested)="onDeleteSapData($event)"
              />
            </div>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel [value]="1">
        <div class="pt-4">
          <app-factories-tab />
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
